const storeTypes = {
  DONATION_STATUS:"DONATION STATUS",
  SPECIFIC_ITEM_STATUS:"SPECIFIC ITEMS STATUS",
  SPECIFIC_ITEMS:"SPECIFIC ITEMS",
  DONATION_LIST:"DONATION LIST",
  ASSETS_LIST:"ASSETS LIST",
  ENTITLEMENT_AGE:"ENTITLEMENT AGE",
}
export default storeTypes;